import React from "react";
import { Users } from "lucide-react";
import Layout from "../components/Layout";
import { teamMembers } from "../data/mockData";

export default function Team() {
  return (
    <Layout title="Team">
      <div className="rounded-2xl border border-[#1B2033] bg-[#0E1220] p-6">
        <div className="flex items-center gap-2 mb-4">
          <Users size={18} className="text-[#5B8DEF]" />
          <h2 className="font-semibold text-[15px]">Your Team</h2>
        </div>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wider text-[#7C8AA5] border-b border-[#1B2033]">
              <th className="py-2">Name</th>
              <th className="py-2">VIP Level</th>
              <th className="py-2">Joined</th>
              <th className="py-2">Earnings Generated</th>
            </tr>
          </thead>
          <tbody>
            {teamMembers.map((m, i) => (
              <tr key={i} className="border-b border-[#161B2C]">
                <td className="py-3">{m.name}</td>
                <td className="py-3 text-[#E0A63C]">{m.level}</td>
                <td className="py-3 text-[#7C8AA5]">{m.joined}</td>
                <td className="py-3 text-[#3FBF8F]">{m.earnings} USDT</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}